import type { GroupSelection } from './groupFilter';

/**
 * Sentinel `<Select>` value for the "Unassigned" option in the main-table
 * "Assign to subgroup…" control — distinct from a real subgroup id so an
 * empty-string id (should never happen) can't be confused with "clear".
 */
export const UNASSIGN_SUBGROUP_VALUE = '__unassigned__';

export interface BulkAssignSubgroupPayload {
  pairIds: string[];
  groupId: string;
  /** null clears the subgroup (the "Unassigned" pick). */
  subgroupId: string | null;
}

/**
 * Builds the `useBulkAssignPairSubgroup` mutate variables for assigning the
 * MAIN table's checked pairs to a subgroup. Returns null when the action is
 * not actionable: no selection, OR the active filter is not a concrete group
 * (subgroups only exist within one group). The `UNASSIGN_SUBGROUP_VALUE`
 * sentinel maps to `subgroupId: null` (clear); any other value is a real id.
 */
export function buildBulkAssignSubgroupPayload(
  selectedPairIds: string[],
  selection: GroupSelection,
  pickedValue: string
): BulkAssignSubgroupPayload | null {
  if (selectedPairIds.length === 0) return null;
  if (selection.kind !== 'group') return null;
  return {
    pairIds: selectedPairIds,
    groupId: selection.groupId,
    subgroupId:
      pickedValue === UNASSIGN_SUBGROUP_VALUE ? null : pickedValue
  };
}
